import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Tooltip } from 'antd';
import Swal from 'sweetalert2';
import { SpanButton } from 'component/button_components/button.style';
import { EnableDisableUser } from 'redux/slices/userSlice';
import { SweetSweetAlert } from 'component/sweetalert_components';
import { ReactComponent as TickIcon } from 'assets/images/SVG/icons/tick-icon.svg';
import { ReactComponent as CancelIcon } from 'assets/images/SVG/icons/cancel-icon.svg';
import { useRefreshUserTab } from 'component/table_component/users_data/refreshUserData';
import ModalOpenLoader from 'component/loader_component/modalOpenLoader';
import { refreshToken } from 'redux/slices/authSlice';

export default function EnableDisableModal({ ...record }) {
  const dispatch = useDispatch();
  const refreshUserTab = useRefreshUserTab();
  const [loader, setLoader] = useState(false);
  const selectedNode = useSelector((state) => state.selectedNode);
  const { mailEnableUser, mailDisableUser, overrideGlobalStatus, domainMailEnableUser, domainMailDisableUser } =
    useSelector((state) => state.settings);
  const canEnableNotify = overrideGlobalStatus?.settings ? domainMailEnableUser ?? true : mailEnableUser ?? true;
  const canDisableNotify = overrideGlobalStatus?.settings ? domainMailDisableUser ?? true : mailDisableUser ?? true;

  const handleAction = async (action) => {
    await dispatch(refreshToken());
    let htmlContent = `
      <div class='af-user-enableOrdisable-notify-wrap' style="display: flex; align-items: center; justify-content: center;">
        <input class='af-user-enableOrdisable-notify-input' type="checkbox" id="notifyByEmail" style="width: 30px; height: 20px;">
        <label class='af-user-enableOrdisable-notify-label' for="notifyByEmail">Notify by email</label>
      </div>
    `;

    const result = await Swal.fire({
      icon: 'warning',
      title: `Are you sure you want to ${action.toLowerCase()} ${record.samAccountName} ?`,
      html: htmlContent,
      showConfirmButton: true,
      confirmButtonColor: 'var(--bg-button-default-color)',
      width: '400px',
      heightAuto: false,
      showCancelButton: true,
      cancelButtonColor: 'green',
      confirmButtonText: action,
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      customClass: {
        container: 'custom-swal-container',
        icon: 'custom-swal-icon',
        title: 'custom-swal-title',
      },
      didRender: () => {
        if (action === 'Enable') {
          const notifyEmailEnable = document.getElementById('notifyByEmail');
          notifyEmailEnable.checked = canEnableNotify;
        } else if (action === 'Disable') {
          const notifyEmailDisable = document.getElementById('notifyByEmail');
          notifyEmailDisable.checked = canDisableNotify;
        }
      },
      preConfirm: () => {
        return {
          notifyByEmail: document.getElementById('notifyByEmail').checked,
        };
      },
    });

    if (result.isConfirmed) {
      try {
        setLoader(true);
        const sweetAlert = await dispatch(
          EnableDisableUser({
            user: record.dn,
            fqdn: selectedNode.domainName,
            notifyEmail: result.value.notifyByEmail,
            domainId: selectedNode.currentdomainId,
          })
        );
        if (sweetAlert.payload && sweetAlert.payload.status === 200) {
          await SweetSweetAlert({ sweetData: sweetAlert.payload.data, icon: 'success', buttonColor: 'green' });
        } else {
          SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
        }
      } catch (error) {
        await SweetSweetAlert({ text: 'Something Wrong Please try again.!!', icon: 'error', buttonColor: 'red' });
      } finally {
        setLoader(false);
        await refreshUserTab();
      }
    }
  };

  if (record.isEnabled === true) {
    return (
      <>
        {loader && <ModalOpenLoader />}
        <Tooltip title='Account is Enabled. Click to Disable' color='#597081'>
          <SpanButton onClick={() => handleAction('Disable')}>
            <TickIcon />
          </SpanButton>
        </Tooltip>
      </>
    );
  }

  return (
    <>
      {loader && <ModalOpenLoader />}
      <Tooltip title='Account is Disabled.Click to Enable' color='#597081'>
        <SpanButton onClick={() => handleAction('Enable')}>
          <CancelIcon />
        </SpanButton>
      </Tooltip>
    </>
  );
}
